/**
 * Brand FAQ Accordion
 * - Native details/summary baseline (works if JS fails)
 * - Smooth open/close via CSS grid rows + controlled toggle
 * - Optional single-open mode
 * - Theme editor section:load / unload safe
 */
(function () {
  var instances = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function BrandFaq(root) {
    this.root = root;
    this.list = root.querySelector('[data-brand-faq-list]');
    this.expandMode = root.getAttribute('data-expand-mode') || 'single';
    this.animMs = parseInt(root.getAttribute('data-anim-ms'), 10);
    if (isNaN(this.animMs)) this.animMs = 280;
    this.reduced = prefersReducedMotion() || this.animMs <= 0;
    this.bound = {};
    this.closingTimers = new WeakMap();

    this.root.classList.remove('no-js');
    this.root.setAttribute('data-reduced-motion', this.reduced ? 'true' : 'false');
    this.bind();
    this.normalizeSingleOpen();
    this.syncAria();
  }

  BrandFaq.prototype.items = function () {
    if (!this.list) return [];
    return Array.prototype.slice.call(this.list.querySelectorAll('[data-brand-faq-item]'));
  };

  BrandFaq.prototype.syncAria = function () {
    var items = this.items();
    for (var i = 0; i < items.length; i++) {
      var summary = items[i].querySelector('.brand-faq__summary');
      if (summary) {
        var expanded = items[i].open && !items[i].classList.contains('is-closing');
        summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }
  };

  BrandFaq.prototype.normalizeSingleOpen = function () {
    if (this.expandMode !== 'single') return;
    var opened = this.items().filter(function (el) {
      return el.open;
    });
    for (var i = 1; i < opened.length; i++) {
      opened[i].open = false;
    }
  };

  BrandFaq.prototype.clearClosingTimer = function (item) {
    var t = this.closingTimers.get(item);
    if (t) {
      clearTimeout(t);
      this.closingTimers.delete(item);
    }
  };

  BrandFaq.prototype.openItem = function (item) {
    if (!item) return;
    this.clearClosingTimer(item);
    item.classList.remove('is-closing');
    if (this.expandMode === 'single') {
      var items = this.items();
      for (var i = 0; i < items.length; i++) {
        if (items[i] !== item && items[i].open) this.closeItem(items[i], true);
      }
    }
    item.open = true;
    this.syncAria();
  };

  BrandFaq.prototype.closeItem = function (item, immediate) {
    var self = this;
    if (!item || !item.open) return;
    this.clearClosingTimer(item);

    if (immediate || this.reduced) {
      item.classList.remove('is-closing');
      item.open = false;
      this.syncAria();
      return;
    }

    // Keep [open] while collapsing grid rows, then remove open.
    item.classList.add('is-closing');
    this.syncAria();
    var timer = setTimeout(function () {
      item.open = false;
      item.classList.remove('is-closing');
      self.closingTimers.delete(item);
      self.syncAria();
    }, self.animMs);
    this.closingTimers.set(item, timer);
  };

  BrandFaq.prototype.toggleItem = function (item) {
    if (!item) return;
    if (item.open && !item.classList.contains('is-closing')) {
      this.closeItem(item, false);
    } else {
      this.openItem(item);
    }
  };

  BrandFaq.prototype.bind = function () {
    var self = this;

    this.bound.onClick = function (event) {
      var summary = event.target.closest('.brand-faq__summary');
      if (!summary || !self.root.contains(summary)) return;
      if (event.target.closest('a')) return;

      event.preventDefault();
      var item = summary.closest('[data-brand-faq-item]');
      self.toggleItem(item);
    };

    this.bound.onKeydown = function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var summary = event.target.closest('.brand-faq__summary');
      if (!summary || !self.root.contains(summary)) return;
      if (event.target !== summary && !summary.contains(event.target)) return;

      event.preventDefault();
      var item = summary.closest('[data-brand-faq-item]');
      self.toggleItem(item);
    };

    this.root.addEventListener('click', this.bound.onClick);
    this.root.addEventListener('keydown', this.bound.onKeydown);
  };

  BrandFaq.prototype.destroy = function () {
    var items = this.items();
    for (var i = 0; i < items.length; i++) {
      this.clearClosingTimer(items[i]);
      items[i].classList.remove('is-closing');
    }
    if (this.bound.onClick) this.root.removeEventListener('click', this.bound.onClick);
    if (this.bound.onKeydown) this.root.removeEventListener('keydown', this.bound.onKeydown);
    instances.delete(this.root);
  };

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new BrandFaq(root));
  }

  function initAll() {
    document.querySelectorAll('[data-brand-faq]').forEach(initRoot);
  }

  function destroyIn(node) {
    if (!node) return;
    var root =
      node.matches && node.matches('[data-brand-faq]')
        ? node
        : node.querySelector && node.querySelector('[data-brand-faq]');
    if (root && instances.has(root)) instances.get(root).destroy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    destroyIn(event.target);
    if (event.target) {
      var root = event.target.querySelector('[data-brand-faq]');
      if (root) initRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target && event.target.closest ? event.target.closest('[data-brand-faq-item]') : null;
    if (!item) return;
    var root = item.closest('[data-brand-faq]');
    if (!root || !instances.has(root)) return;
    instances.get(root).openItem(item);
    try {
      item.scrollIntoView({ block: 'nearest', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    } catch (e) {}
  });
})();
